var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.466 17c-.66 0-.967-.419-2.288-1.608l-2.797-2.6c-.508-.473-.508-1.183 0-1.655a1.294 1.294 0 011.78 0l2.797 2.6c.254.236.508.236.508.236.254 0 .509-.236.509-.236l6.864-6.382a1.294 1.294 0 011.78 0c.508.472.508 1.181 0 1.654l-6.865 6.383C11.406 16.777 11.126 17 10.466 17z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2d0f6ce1efbecebc6860cc5feb851843.svg";
export { ForwardRef as ReactComponent };